var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.797 5.99c.005.275-.103.54-.299.734-.195.195-.461.3-.737.294-.272.005-.535-.103-.725-.298-.19-.195-.293-.46-.283-.731V3.8c0-.04-.025-.078-.063-.094-.038-.015-.082-.007-.111.022L1.647 8.58c-.229.23-.77.391-1.306-.146-.395-.326-.456-.909-.136-1.31l4.86-4.904c.03-.03.038-.073.022-.112-.016-.038-.053-.062-.094-.063H2.727c-.565 0-1.023-.457-1.023-1.022S2.162 0 2.727 0h5.661c.226 0 .41.183.41.41v5.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRisk);
export default __webpack_public_path__ + "static/media/high-risk.9947ad6ebef1644fcdbf53262f90c548.svg";
export { ForwardRef as ReactComponent };